// Doc: https://pay-gateway-dev.internal.thinxcloud.de/specs/openapi/#/loyalty-subscriptions

import axios from './index';
import { PayloadSubscribeLoyalty } from '@/store/loyalty/types';


export const subscribeLoyalty = async (payload: PayloadSubscribeLoyalty) => {
  await axios({
    method: 'post',
    url: '/v4/loyalty-subscriptions/',
    data: {
      ...payload
    }
  });

};

export const deactivateLoyalty = async (subscriptionId:string) => {
  await axios.delete(`/v4/loyalty-subscriptions/${subscriptionId}`);
};

export const getActiveLoyalty = async () => {
  const response = await axios.get(`/v4/loyalty-subscriptions`);
  if (response.status >= 400 && response.status <= 502) {
    throw new Error('Retrieving active loyalty programs failed');
  }
  return response.data;
};
